<template>
  <div>
    <el-dialog
        title="图形校验"
        :visible.sync="dialogVisible"
        width="450px"
        :before-close="handleClose"
        @close="handleClose"
        v-if="dialogVisible"
    >
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0px"
          class="demo-ruleForm flex-dir-center"
          v-loading="loading"
      >
        <el-form-item class="verify-item" prop="captcha">
          <el-input
              @keyup.enter="submitForm"
              style="width: 250px; margin-right: 10px"
              v-model="ruleForm.captcha"
              placeholder="请输入验证码"
          ></el-input>
          <!-- 验证码图片 -->
          <img @click="getCapt" :src="capUrl" style="height:38px;width:120px" alt/>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="sub-button" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {GVerify} from "@/utils/verify.js";

export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        captcha: undefined
      },
      capUrl: null,
      rules: {
        captcha: [{required: true, message: "请输入验证码", trigger: "blur"}]
      },
      loading: false
    };
  },
  methods: {
    show(phone) {
      this.ruleForm.telephone = phone
      this.getCapt();
      this.dialogVisible = true;
    },
    getCapt() {
      this.loading = true;
      this.$http.post(this.$api.login.getCaptcha, {telephone: this.ruleForm.telephone}).then(res => {
        this.loading = false;
        if (res.data.code == 200) {
          // this.ruleForm.uuid = res.data.uuid;
          // this.capUrl = "data:image/jpeg;base64," + res.data.img;
          this.capUrl = res.data.data.captcha;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate(async value => {
        if (value) {
          this.$emit("getMessage", this.ruleForm);
          this.handleClose();
        }
      });
    },
    handleClose() {
      this.loading = false;
      this.ruleForm.uuid = "";
      this.ruleForm.captcha = "";
      this.capUrl = "";
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.verify-item {
  ::v-deep .el-form-item__content {
    display: flex;
    justify-content: space-between;
  }
}

.sub-button {
  width: 138px;
  height: 42px;
  font-size: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 30px 0;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}
</style>
